export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {userId, apiToken},
      } = store.getState()

      if (apiToken) {
        // config.headers.Authorization = `Bearer ${apiToken}`;
        config.headers = {
          'User-Id': `${userId}`,
          'Api-Token': `${apiToken}`,
        }
      }

      console.log(config.url, config)

      return config
    },
    (err: any) => Promise.reject(err),
  )
}
